import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Plus } from "lucide-react";
import { UserButton } from "@clerk/react";
import { CaptureContext } from "@/components/CaptureContext";
import CaptureModal from "@/components/CaptureModal";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/brain", label: "Brain" },
  { to: "/archive", label: "Archive" },
];

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const openCapture = () => setOpen(true);

  return (
    <CaptureContext.Provider value={{ openCapture }}>
      <div className="min-h-screen bg-background text-foreground">
        <header
          data-testid="top-header"
          className="sticky top-0 z-50 backdrop-blur-xl bg-white/60 border-b border-white/50"
        >
          <div className="mx-auto max-w-7xl px-4 md:px-8 h-14 md:h-16 flex items-center justify-between">
            <div className="flex items-center gap-5 md:gap-8">
              <a href="/" data-testid="logo-link" className="font-serif text-xl md:text-2xl tracking-tight">
                Becoming
              </a>
              <nav className="flex items-center gap-3.5 md:gap-6">
                {NAV.map(({ to, label, end }) => (
                  <NavLink
                    key={to}
                    to={to}
                    end={end}
                    data-testid={`nav-link-${label.toLowerCase()}`}
                    className={({ isActive }) =>
                      `text-xs md:text-sm font-medium transition-colors ${
                        isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                      }`
                    }
                  >
                    {label}
                  </NavLink>
                ))}
              </nav>
            </div>
            <div className="flex items-center gap-2.5 md:gap-3">
              <button
                data-testid="add-button-desktop"
                onClick={openCapture}
                className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 md:px-5 py-2 md:py-2.5 text-sm font-semibold shadow-sm hover:opacity-90 transition-[opacity,box-shadow] hover:shadow-md"
              >
                <Plus className="h-4 w-4" /> <span className="hidden sm:inline">Capture</span>
              </button>
              <div data-testid="user-menu">
                <UserButton afterSignOutUrl="/" />
              </div>
            </div>
          </div>
        </header>

        <main className="mx-auto max-w-7xl px-4 md:px-8 pt-8 pb-16">{children}</main>

        {open && <CaptureModal open={open} onClose={() => setOpen(false)} />}
      </div>
    </CaptureContext.Provider>
  );
}
